import Image from 'next/image'
import type { Brand } from '@/config'
import { cn } from '@/lib/utils'

type BrandLogoProps = Readonly<{
  brand: Pick<Brand, 'logo' | 'logoDark' | 'logoAlt'>
  className?: string
  sizes?: string
}>

export function BrandLogo({
  brand,
  className,
  sizes = '160px',
}: BrandLogoProps) {
  return (
    <span
      role="img"
      aria-label={brand.logoAlt}
      className={cn('relative inline-block shrink-0', className)}
    >
      <Image
        src={brand.logo}
        alt=""
        fill
        sizes={sizes}
        loading="lazy"
        className="object-contain dark:hidden"
      />
      <Image
        src={brand.logoDark}
        alt=""
        fill
        sizes={sizes}
        loading="lazy"
        className="hidden object-contain dark:block"
      />
    </span>
  )
}
